export default __webpack_public_path__ + "static/media/Group 2.ff0c0f43.svg";